<template>
<div class="step__body">
  <component
  :is="(option.type || 'select') + 'Option'"
  :key="option.id"
  :option="option"
  v-for="option in options"/>
</div>
</template>
<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import SelectOption from './selectOption'
export default {
  name: 'Simpletechnic',
  components: {
    SelectOption
  },
  setup () {
    const store = useStore()
    const options = computed(() => {
      return store.getters['configurator/currentOptions']
    })
    return {
      options
    }
  }
}
</script>
